// productData.js
import { Link } from 'react-router-dom';

export const productData = {
    "colby-blinds": {
        id: "colby-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Colby Blinds - designed to provide beauty and energy efficiency',
        META_PG_OG_Description: 'Colby / Honeycomb Blinds has unique light & privacy control combinations of light filtering & room darkening engineered for energy efficiency',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/colby-blinds/',

        name: "Colby Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-slider-04.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-slider-01.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-slider-02.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-slider-04-2-1-1-scaled.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-03.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-04.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-05.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-06.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-07.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-08.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-09.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-10.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-11.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-13.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-01.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/colby-inspiration-02.webp'
            ],
            text: [
                <>
                    <p>
                        Most energy efficient blinds specifically engineered to provide beauty and energy efficiency in both cold and warm climates. Callistus Colby Blind combines soft, seamless fabrics with crisp even pleats that hold their shape indefinitely. Choose <b>Top-Down / Bottom-Up</b> and open your shades from the top, bottom, or both. <b>Callistus Colby Blinds</b> are available in a wide range of 28 beautiful fabrics, rich structures and colours in three transparencies. They give a beautiful pleat pattern to your windows.
                    </p>
                    <p>
                        <b>Callistus Colby Blind</b> fabric allows you to have the same colour in all three transparencies – depending on the level of privacy that you desire and the amount of light you want, you can choose different transparency in every space.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        <b>Most energy efficient</b> blinds specifically engineered to provide beauty and energy efficiency in both cold and warm climates. <b>Callistus Colby Blind</b> combines soft, seamless fabrics with crisp even pleats that hold their shape indefinitely. Choose <b>Top-Down / Bottom-Up</b> and open your shades from the top, bottom, or both.
                    </p>
                    <p>
                        <b>Callistus Colby Blinds</b>, also known as Honeycomb Blinds, Cellular Blinds, come with unique light & privacy control combinations including sheer, light filtering, room darkening, and blackout fabrics to provide you with various levels of privacy, light control and luxury.
                    </p>
                    <p>
                        <b>Callistus Colby</b> Blinds are available in a wide range of 28 beautiful fabrics, rich structures and colours in three transparencies. They give a beautiful pleat pattern to your windows.
                    </p>
                    <p>
                        <b>Callistus Colby</b> Blind fabric allows you to have the same colour in all three transparencies – depending on the level of privacy that you desire and the amount of light you want, you can choose different transparency in every space.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Sheer, Translucent & Blackout' },
                { label: 'Width (in mm)', value: '300 to 3000' },
                { label: 'Drop (in mm)', value: '300 to 5000' }
            ],
            video: "https://www.youtube.com/embed/RjKXvRbFzcA?si=URZ_y8QbDHws5kJv",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Colby Blinds",
            systems: [
                {
                    title: 'Clutch System',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/clutch-system-e1589892283945.webp',
                    description:
                        <>
                            <b>Callistus</b> Clutch System for Colby blinds uses a retractable cord to raise and lower your blind while maintaining a constant cord length. There are no long, dangling cords to detract from the appearance of your window covering. Ideal for child and pet safety.
                        </>
                },
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/manual-e1589892658172.webp',
                    description:
                        <>
                            One of the most important advantages of <b>Callistus window</b> coverings is their ease of operation. A continuous ball chain / cord loop works on the principle of a pulley, rotating a clutch to open or close the blind.
                        </>
                },
                {
                    title: 'Top-Down / Bottom-Up',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/top-Down-e1589892128193.webp',
                    description:
                        <>
                            <b>Callistus Colby Blind</b> Top-Down/Bottom-Up system offers you the ability to operate window blind from the top down or the bottom up to meet all your privacy needs while still giving you access to natural light. <br /><Link to="/top-down-bottom-up">Learn More</Link>
                        </>
                },
                {
                    title: 'Day & Night',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/Day-Night-e1589892712523.webp',
                    description:
                        <>
                            Day & Night system offers maximum light control by using two separate fabrics to achieve a day/night level of convenience, providing limitless options for privacy and light control. Day & Night system is available in the following combination options: <br /> 1) Visible – Translucent <br /> 2) Visible – Blackout <br /> 3) Translucent – Blackout <br /><Link to="/colby-blinds-day-and-night">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/Remote-e1589892304795.webp',
                    description:
                        <>
                            The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls are available in different colours and can also be affixed to a wall. Learn More <br /><Link to="/colby-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            <b>Callistus</b> Automation blinds can be operated using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                }
            ]
        },
        solutions: {
            text: [
                <>
                    <p>
                        Most of the heat is lost or gained through the windows, even when double glazed. Callistus Colby Blinds offer an amazing solution for the same. Callistus Colby Blinds have a layer of silver foil inside, which makes them energy saving window coverings that retain the internal temperature, while simultaneously adding substantial beauty to the interior. Moreover, they noticeably improve the acoustics in the room.
                    </p>
                    <p>
                        Callistus Colby Blinds come in various combinations which are mentioned below. These combinations serve all the demands with regard to Light Control or Privacy.
                    </p>
                </>
            ],
            combinations: [
                {
                    title: 'Translucent & Blackout',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/BT.webp',
                    description: 'This is a combination of Blackout and Translucent fabrics, wherein one can maintain constant natural light or can darken the room completely as per need.'
                },
                {
                    title: 'Visible & Blackout',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/SB.webp',
                    description: 'Visible & Blackout consists of two fabrics, one is the visible fabric and the other is the Blackout fabric. With the sheer fabric, you can enjoy an almost clear view of the outside and reasonably protect yourself from direct sunlight, while blackout gives you complete control of your privacy.'
                },
                {
                    title: 'Visible & Translucent',
                    image: '/Assets/SubPagesImages/ColbyBlindsImages/ST.webp',
                    description: 'If enjoying natural light while maintaining privacy is what you are looking for, then the combination of Sheer and Translucent is the answer to that. Sheer fabric illuminates the room with natural light, and Translucent fabric takes care of privacy while diffusing the light softly.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/ColbyBlindsImages/9.-1954-ckb.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/8.-1924-cmt.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/7.-1953-ckb.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/6.-1952-ckb.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/5.-1923-cmt.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/4.-1955-ckb.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/3.-1926-cmt.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/2.-1922-cmt.webp',
                '/Assets/SubPagesImages/ColbyBlindsImages/1.-1951-ckb.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/colby-blinds/colby-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "sierra-blinds": {
        id: "sierra-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Sierra Blinds - A brilliant way to dress up your windows!',
        META_PG_OG_Description: 'Sierra Blinds protecting you from UV Rays, combines practical qualities of slats with warmth & intimacy of curtains in a truly elegant manner',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/sierra-blinds/',

        name: "Sierra Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/SierraBlindsImages/slider-slider-02.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/slider-slider-03.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/slider-slider-04.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/slider-slider-01.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-inspiration-07.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-inspiration-08.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/05-sierra-inspiration.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/08-sierra-inspiration.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-inspiration-01.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-inspiration-02.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-inspiration-03.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-inspiration-04.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra-inspiration-05.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/sierra_Inspiration_new01.webp',
            ],
            text: [
                <>
                    <p><b>A brilliant way to dress up your windows!</b></p>
                    <p>
                        <b>Callistus Sierra Blind</b> is an innovative way of decorating your home. It combines the practical qualities of slats with the warmth and intimacy of the curtains in a truly elegant manner.
                    </p>
                    <p>
                        Their exclusive elegance is designed to improve the appearance of your interior and to provide a touch of style. These type of blinds integrate well with both – modern interiors as well as classical designs, because of the way they harmoniously combine practical attributes with distinctive allure.
                    </p>
                    <p>
                        If you are looking to create an instant impact at your home with something a little different, then <b>Sierra Blinds</b> would be a perfect choice. <b>Sierra Blinds</b> really come into their own in larger windows where their unique flowing fabric vanes allow you to enjoy both light and privacy.
                    </p>
                    <p>
                        <b>Sierra blinds</b> also help protect your floors and furniture from <b>UV</b> damage, with their silver foils which are placed inside the vanes while maintaining the outside view. You can select colours and fabrics that coordinate with other <b>Callistus</b> Window Blinds to create an integrated look in any room, or across your entire space.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        A brilliant way to dress up your windows!
                    </p>
                    <p>
                        <b>Callistus Sierra Blind</b> is an innovative way of decorating your home. It combines the practical qualities of slats with the warmth and intimacy of the curtains in a truly elegant manner.
                    </p>
                    <p>
                        <b>Sierra blinds</b> not only look great in the home but they are perfect for both domestic and commercial spaces.
                    </p>
                    <p>
                        Their exclusive elegance is designed to improve the appearance of your interior and to provide a touch of style. These type of blinds integrate well with both – modern interiors as well as classical designs, because of the way they harmoniously combine practical attributes with distinctive allure.
                    </p>
                    <p>
                        If you are looking to create an instant impact at your home with something a little different, then <b>Sierra Blinds</b> would be a perfect choice. Sierra Blinds really come into their own in larger windows where their unique flowing fabric vanes allow you to enjoy both light and privacy.
                    </p>
                    <p>
                        Available in many trending colour options, <b>Sierra blinds</b> also help protect your floors and furniture from UV damage, with their silver foils which are placed inside the vanes while maintaining the outside view. You can select colours and fabrics that coordinate with other <b>Callistus Window Blinds</b> to create an integrated look in any room, or across your entire space.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Vertical' },
                { label: 'Visibility', value: 'Blackout' },
                { label: 'Width (in mm)', value: '550 to 4500 (in Automation 4000)' },
            ],
            video: "https://www.youtube.com/embed/7oqcU7T4L3o?si=fZ4NzmZh61mZ_G3C",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Sierra blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/SierraBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind. <br /><Link to="/sierra-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/SierraBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            Motorised Remote Control allows you to preset and easily operate window blinds with just a press of a button.
                        </>
                },
                {
                    title: 'Wand Control',
                    image: '/Assets/SubPagesImages/SierraBlindsImages/wand-control-e1589892259253.webp',
                    description:
                        <>
                            Callistus offers Wand control for Sierra Blinds, so there are no cords, making them completely Child Safe by Design. You can control the blind and draw it to either the left or right as per your need.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                <>
                    <p>
                        Sierra Blinds unique weave offers the ultimate shading flexibility and privacy along with modern stunning fabrics.
                    </p>
                    <p>
                        Cleverly combining the delicacy of a voile fabric with the versatility of rotating vertical louvres, Sierra blind looks sensational and offers a number of light and privacy options.
                    </p>
                    <p>
                        With the fabric vanes open during the day, you can still enjoy your view. When closed at night, you can have total privacy, and warmth.
                    </p>
                    <p>
                        All our blinds are of course child safe and Sierra Blind is another example of this. It also comes with automation control, giving you complete peace of mind in a convenient, efficient and practical way.
                    </p>
                    <p>
                        Not to forget, Sierra Blinds come with embedded silver foil which provides UV Protection and insulation, saving energy eventually.
                    </p>
                </>
            ],
            combinations: [
                {
                    title: 'Fabric Vanes for Light and Privacy Control',
                    image: '/Assets/SubPagesImages/SierraBlindsImages/sierra-fabric-vanes-bottom.webp',
                    description:
                        <>
                            <b>Full View:</b> Slide the soft fabric vanes to one side or split from center to enjoy a clear outside view. <br />

                            <b>Day Time with Privacy:</b> Open up the soft fabric vanes to the open position and enjoy subtle light diffusion with a view. <br />

                            <b>Total Privacy:</b> Rotate the vanes to close the blind fully for total privacy.
                        </>
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2401-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2402-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2403-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2404-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2405-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2406-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2407-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2421-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2422-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2423-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2424-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2425-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2441-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2442-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2443-300x167.webp',
                '/Assets/SubPagesImages/SierraBlindsImages/SOB-2444-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "grayson-blinds": {
        id: "grayson-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Grayson Blinds - the combination of Roller & Venetian Blinds',
        META_PG_OG_Description: 'Callistus Grayson Blinds give you privacy while offering view to outside by tilting vanes, creating beautiful gradations of light & shadow',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/grayson-blinds/',

        name: "Grayson Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/GraysonBlindsImages/Grayson-Slider-.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/Grayson-Slider-02.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-slider-01-2.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-slider-04.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-slider-2.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/GraysonBlindsImages/Grayson-15-1.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-inspiration-15.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/07-Grayson-inspiration.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/06-Grayson-inspiration.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/05-Grayson-inspiration.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/04-Grayson-inspiration.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-01.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/Grayson-02.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-03.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-04.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/Grayson-05.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-inspiration-13.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/Gryason-inspiration-011.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/Grayson-07.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-inspiration-07.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-inspiration-08.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/Grayson-10-1.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/Gryason-inspiration-010.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/grayson-inspiration-11.webp',
            ],
            text: [
                <>
                    <p>
                        <b>Callistus Grayson Blinds</b> give you privacy while offering a view to the outside. It is the combination of <b>Roller & Venetian Blinds</b>. It easily creates beautiful gradations of light and shadow. Soft fabric vanes are suspended between two sheers, diffusing softened light deep into a room. Tilt the vanes to suit the privacy you desire.
                    </p>
                    <p>
                        Superbly stylish, <b>Callistus Grayson Blinds</b> take the harshest sunlight and transform it into beautiful ambient natural light. Simply tilt the vanes to enjoy more natural daylight by diffusing it evenly throughout the space whilst filtering out brightness, glare and UV rays.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        <b>Callistus Grayson Blinds</b> give you privacy while offering a view to the outside. It is the combination of Roller & Venetian Blinds. It easily creates beautiful gradations of light and shadow. Soft fabric vanes are suspended between two sheers, diffusing softened light deep into a room. Tilt the vanes to suit the privacy you desire.
                    </p>
                    <p>
                        Superbly stylish, <b>Callistus Grayson Blinds</b> take the harshest sunlight and transform it into beautiful ambient natural light. Simply tilt the vanes to enjoy more natural daylight by diffusing it evenly throughout the space whilst filtering out brightness, glare and UV rays.
                    </p>
                    <p>
                        <b>Callistus Grayson Blinds</b> are available in a wide range of beautiful fabrics with sophisticated trending colours.
                    </p>
                    <p>
                        Each fabric has its own unique feel, with a choice of silk looks, subtle linens – all designed to create softly filtered light.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Translucent & Dimout' },
                { label: 'Width (in mm)', value: '500 to 2800' },
                { label: 'Drop (in mm)', value: '600 to 4500' },
            ],
            video: "https://www.youtube.com/embed/KWtg1kHz9_Q?si=B5a0s0VbOQNXaWIG",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Grayson Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/GraysonBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind. <br /><Link to="/grayson-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/GraysonBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall. <br /><Link to="/grayson-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/GraysonBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            Callistus Automation blinds can be operated using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                <>
                    <p>
                        Callistus Grayson Blinds are the best choice for protecting privacy and controlling the light transmitted. Blind slices are clamped between two layers of sheer fabrics. Grayson Blinds close the gap between Venetian Blinds and Curtains in a truly unique design.
                    </p>
                    <p>
                        The shadings can be opened for a soft view, closed for complete privacy or tilted for flexible light control. They are durable and easy to clean.
                    </p>
                </>
            ],
            combinations: [
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/GraysonBlindsImages/grayson-blinds-decorative-cassette.webp',
                    description:
                        <>
                            Add a touch of luxury to your blind by adding a contemporary cassette. This system improves the look of the blind whether it is in the retracted or extended position. The blind get a glamorous enhancement with a Decorative Cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.
                        </>
                },
                {
                    title: 'Fixing Option - Plain Cassette',
                    image: '/Assets/SubPagesImages/GraysonBlindsImages/grayson-blinds-plain-cassette.webp',
                    description:
                        <>
                            Give your blinds a sophisticated look by adding a sleek yet elegant Plain Cassette. If the blind is pulled up, the fabric in the upper part is wound onto the winding system. In this system, the roller lap is hidden in the box, whose size is determined according to the dimensions of the blinds. Plain Cassette completely encloses your blind’s mechanism thereby maintaining the integrity of your interior.
                        </>
                },
                {
                    title: 'Light Diffusion',
                    image: '/Assets/SubPagesImages/GraysonBlindsImages/grayson-blinds-solutions-diffusion.webp',
                    description:
                        <>
                            Simply tilt the vanes to enjoy more natural daylight by diffusing and spreading it evenly throughout the room whilst filtering out brightness, glare and UV rays.
                        </>
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/GraysonBlindsImages/9.-GTB-1762-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/8.-GDT-1707-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/3.-GDT-1710-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/6.-GKT-1724-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/5.-GAB-1754-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/4.-GFB-1742-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/2.-GDT-1703-thumb.webp',
                '/Assets/SubPagesImages/GraysonBlindsImages/1.-GCT-1771-thumb.webp'
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/grayson-blinds/grayson-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "roller-blinds": {
        id: "roller-blinds",
        // Page Meta Fields
        META_PG_OG_Title: 'Roller Blinds for your Home & Office - Latest Window Coverings | Window Roller Shades | Roller Blinds Manufacturer | Best Price Roller Window Blinds | UK, UAE, Dubai | USA | Canada | Oman | Bahrain',
        META_PG_OG_Description: 'Roller Blinds Enlighten any space with colour, design & texture for spawning blackout. Dazzling choice of fabrics with 650+ awesome color shades. Roller Blinds are perfect for any setting seeing as they add style, functionality and appeal to the windows. Roller blinds are custom made to fit the size of your windows and are available in a number of designs blackout fabric. We are a leading Roller Blind Manufacturer with Global Presence. Available in translucent, dim-out and blackout fabrics. Motorization with remote control | Best Quality Durability Roller Blinds for Windows | Wide range of roller fabrics fabrics providing premium solution for room & office light control | UAE, UK, Oman, UK, Bahrain, Canada | Roller blinds enhances performance, look, appearance of home & office interiors | No compromise quality, manual & motorized remote controlled solution',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/roller-blinds/',

        name: "Roller Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-03-1.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-05.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-07.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-06.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-01-1.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-04-1.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-slider-02-1.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/RollerBlindsImages/06-Roller-inspiration.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/roller-inspiration-01.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_02.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_03.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_04.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_05.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_06.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_07.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_08.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_09.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_10.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_11.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_12.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_13.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_14.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_15.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_16.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_17.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_18.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_19.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller-inspiration-20.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/Roller_Inspiration_21.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/07-Roller-inspiration.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/05-Roller-inspiration.webp',
            ],
            text: [
                <>
                    <p>
                        Gently diffusing the light to create an astonishing ambiance Callistus <Link to="/products/roller-blinds" >Roller Blinds</Link> can enlighten any space with its colour, design and texture. Control the natural light, spawning instant blackout. Callistus offers the contemporary range meeting all interior design requirements.
                    </p>
                    <p>
                        <b>Callistus <Link to="/products/roller-blinds" >Roller Blinds</Link></b> are the pinnacle of elegance when it comes to window coverings. Ultra-Modern blinds in design, stylish, reliable and easy to operate. A wide range of operating systems ensures the blinds can be operated easily to achieve the required level of privacy and light control.
                    </p>
                    <p>
                        <b>Dazzling choice of fabrics with 650+</b> awesome designs and colors. Available in Plain Cassette and Fabric Decorative Cassette, Matching or Fabric Wrapped Bottom to personalize interior design choice and elevate beauty.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Gently diffusing the light to create an astonishing ambience Callistus <b>Roller Blinds</b> can enlighten any space with its colour, design and texture. Control the natural light and spawning instant blackout. <b>Callistus</b> offers the contemporary range meeting all interior design requirements.
                    </p>
                    <p>
                        <b>Callistus Roller Blinds</b> are the pinnacle of elegance when it comes to window coverings. Ultra-Modern blinds in design, stylish, reliable and easy to operate. A wide range of operating systems ensures the blinds can be operated easily to achieve the required level of privacy and light control.
                    </p>
                    <p>
                        <b>Dazzling choice of fabrics with 650+</b> awesome designs and colours. Available in Plain Cassette and Fabric Decorative Cassette, Matching or Fabric Wrapped Bottom to personalise interior design choice and elevate beauty.
                    </p>
                    <p>
                        We are Leading Manufacturers of <Link to="/" >Window Blinds</Link>
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Sheer, Translucent & Blackout' },
                { label: 'Width (in mm)', value: '300 to 3000' },
                { label: 'Drop (in mm)', value: '300 to 6000' },
            ],
            video: "https://www.youtube.com/embed/ta5nZE_Rfdk?si=B-hG2LrsdHO51BFT",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Roller Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus <Link to="/" >window coverings</Link> is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the <Link to="/" >window blinds</Link>. <br /><Link to="/roller-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to preset and easily operate a group of up-to sixteen different <Link to="/" >window blinds</Link>, individually or together with just a press of a button. Remote Controls can also be affixed to a wall.<br /><Link to="/roller-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            Callistus Automation Blinds can be operated using an App. You can control your <Link to="/" >blinds</Link> with a swipe of a finger, or create customized scenes that move the <Link to="/" >blinds</Link> to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
                {
                    title: 'One Touch Up',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/one-tuch-up-e1590554714287.webp',
                    description:
                        <>
                            One Touch Up is a smart system wherein you just need to pull the operating cord, and the blind will roll up on its own.<br /><Link to="/roller-blinds-one-touch-up">Learn More</Link>
                        </>
                },
            ]
        },
        solutions: {
            text: [
                <>
                    <p className="solution-c-title">
                        Fabric that owns a unique feel
                    </p>
                    <p>
                        Callistus Blinds offer textures that are a literal treat to your eyes. With softness and drama of contrasting colours that come in natural and rough texture, they are not only reflective but also look icy elegant
                    </p>
                    <p>
                        <b>Callistus’ designer fabrics</b> <br />
                        Fabrics that raise the brows allowing your imaginations to run wild. Our wonderful collection allows you to choose from 650+ fabric colours, textures and patterns.
                    </p>
                    <p>
                        <b>Automation in Blinds</b> <br />
                        Automation in blinds gives your home a touch of originality, improves function and adds value. It makes complete sense for those hard to reach places. We offer a blend of design, technology and innovation that is easy to use and amazingly versatile. You can also choose from a wide range of portable controllers to fulfill all your automation needs and comforts
                    </p>
                    <p>
                        <b>Related Products:</b> <br />
                        <Link to="/products" >Window Blinds</Link> |
                        <Link to="/luzon-blinds" > Luzon Blinds</Link> |
                        <Link to="/roman-blinds" > Roman Blinds</Link>
                    </p>
                </>
            ],
            combinations: [
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/decorative-cassette-4.webp',
                    description:
                        <>
                            Add a touch of luxury to your blind by adding a contemporary cassette. This fixing improves the look of the blind whether it is in the retracted or extended position. The blind get a glamorous enhancement with a Decorative Cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.
                        </>
                },
                {
                    title: 'Fixing Option - Plain Cassette',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/plain-cassette-4-1.webp',
                    description:
                        <>
                            Give your blinds a sophisticated look by adding a sleek yet elegant Plain Cassette. If the blind is pulled up, the fabric in the upper part is wound onto the winding system. In this system, the roller lap is hidden in the cassette, whose size is determined according to the dimensions of the blinds. Plain Cassette completely encloses your blind’s mechanism thereby maintaining the integrity of your interior.
                        </>
                },
                {
                    title: 'Fixing Option - Headrail',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/head-rail-1.webp',
                    description:
                        <>
                            This is one of the leading fixing options. Headrails are essentially the part of the blind which accommodates the operating system that makes the blind go up and down. Headrail blends with any operating system, whether Automation or Manual. This fixing option also plays a vital role in maintaining the balance of in case of bigger size blinds.
                        </>
                },
                {
                    title: 'Fixing Option - Direct Fix',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/Roller-Blinds-Solution-Direct-Fix.webp',
                    description:
                        <>
                            Being a traditional fixing option, Direct Fix is simple and one of the most popular fixing option which is equipped with a chain mechanism. It works on clamps which can either be fixed as Ceiling Fix or Wall Fix.
                        </>
                },
                {
                    title: 'Bottom Rail',
                    image: '/Assets/SubPagesImages/RollerBlindsImages/bottom-rail.webp',
                    description:
                        <>
                            Callistus provides various options in bottom rails according to the blinds. We have options of Round, Pentagon and Decorative Bottom Rails with 19 different colours to choose from. These Bottom Rails blend beautifully with the blinds enhancing their look by making them more stylish and sophisticated.
                        </>
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/RollerBlindsImages/9.-sisal-3616-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/8.-Harp-4027-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/7.-MAX-3648-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/6.-rio-3623-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/5.-mist-4004-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/4.-Colourex-3581-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/3.-Clio-3554-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/2.-missoni-3061-thumb.webp',
                '/Assets/SubPagesImages/RollerBlindsImages/1.-STARTA-3045-thumb.webp'
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/roller-blinds/roller-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "wooden-venetian-blinds": {
        id: "wooden-venetian-blinds",
        // Page Meta Fields
        META_PG_OG_Title: 'Wooden Venetian Blinds Natural Basswood Faux Metallic Series | Buy',
        META_PG_OG_Description: 'Decorate Windows with stunning, highly durable Wooden Venetian Blinds reflecting your style, luxury & premium crearing contemporary window look. See the full list of Venetian Blinds. Venetian Blinds styles for cosy ambience in every room of home & office. High Quality & Durable material for every Window Venetian Blinds, the perfect solution for every window with wooden venetian blinds.',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/wooden-venetian-blinds/',

        name: "Wooden Venetian Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-slider-04.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-slider-05.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-slider-01-1.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-slider-02-1.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-slider-03-1.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/Wooden_Inspiration_05.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-inspiration-06.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/Wooden_Inspiration_08.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-inspiration-07.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-inspiration-09.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-inspiration.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-inspiration0.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-inspiration-02.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-inspiration-01.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wooden-inspiration-03.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/Wooden_Inspiration_04.webp',
            ],
            text: [
                <>
                    <p>
                        <b>Callistus Wooden Venetian Blinds</b> add a timeless style to your windows. Choose from the most wonderful collection of natural Basswood and Faux Metallic Series to complete and add royalty to your interior. Decorate your windows with Wooden Blind that reflects your style and luxury creating a contemporary look
                    </p>
                    <p>
                        Our range of classy <b>Wooden Venetian blinds</b> are not just stunning but also highly durable, so they can easily handle the heat & humidity without fading or warping.
                    </p>
                    <p>
                        Whether you want to gently filter daylight without spoiling the view or close them for total privacy or filtered light, <b>Wooden Venetian blinds</b> are a stylish and practical choice.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Callistus Wooden Venetian Blinds add a timeless style to your windows. Choose from the most wonderful collection of natural Basswood and Faux Metallic Series to complete and add royalty to your interior. Decorate your windows with Wooden Blind that reflects your style and luxury creating a contemporary look
                    </p>
                    <p>
                        Our range of classy Wooden blinds are not just stunning but also highly durable, so they can easily handle the heat & humidity without fading or warping.
                    </p>
                    <p>
                        Whether you want to gently filter daylight without spoiling the view or close them for total privacy or filtered light, Wooden Venetian blinds are a stylish and practical choice.
                    </p>
                </>
            ],
            specs: [
                { label: 'Slat Size (in mm)', value: '50 mm' },
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Width (in mm)', value: '300 to 2400 (in Faux Metallic Series 2900)' },
            ],
            video: "https://www.youtube.com/embed/Mlvmsv_g6xQ?si=fPY3l6hthgBxt-PD",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Wooden Venetian Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/WoodenVenetianBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/wooden-venetian-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/WoodenVenetianBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall.<br /><Link to="/wooden-venetian-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/WoodenVenetianBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            Callistus Automation blinds can be operated using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Design and Finishing',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Wooden <Link to="/products/wooden-venetian-blinds" >Venetian Blinds</Link> add a timeless style to your window. Choose from a wonderful collection of natural Basswood and Faux Metallic Series to complete and add elegance to your interior. Enjoy a Wooden Venetian blinds that reflects your style.
                            </p>
                        </>
                },
                {
                    title: 'Perfect choice with a contemporary look',
                    image: null,
                    description:
                        <>
                            <p>
                                Our range of classy <Link to="/products/wooden-venetian-blinds" >Wooden Blinds</Link> aare not just stunning, they are also highly durable, so they can easily handle the heat & humidity without fading or warping.
                            </p>
                        </>
                },
                {
                    title: 'Customise as per your need',
                    image: null,
                    description:
                        <>
                            <p>
                                You can combine different coloured slats to provide a fancy look to your interior. Personalize with a wide choice of sleek & decorative ladder tape to enrich the view of the blind.
                            </p>
                        </>
                },
                {
                    title: 'Valance System',
                    image: '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wv-blinds-valance-system.webp',
                    description: 'The valance will brilliantly cover the headrail, accentuating the beauty of the blind while concealing the operating system simultaneously.'
                },
                {
                    title: 'Ladder Tape',
                    image: '/Assets/SubPagesImages/WoodenVenetianBlindsImages/wv-blinds-ladder-tape.webp',
                    description: 'Callistus has designed an attractive range of slim Ladder Tapes of 13mm which gives a sophisticated look and complements your blinds. There are as many as 26 colours available to choose from, to match with your wooden slat. A different colour of ladder tape can also be used to give a contrasting look.'
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/9.-PD-76-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/8.-RS-03-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/7.-RS-01-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/6.-PD-78-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/5.-SP-51-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/4.-RS-08-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/3.-PD-80-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/2.-FM-33-300x167.webp',
                '/Assets/SubPagesImages/WoodenVenetianBlindsImages/1.-FM-31-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/wooden-venetian-blinds/wooden-slates",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "luzon-blinds": {
        id: "luzon-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Zebra Luzon Blinds - ideal balance of privacy and light control',
        META_PG_OG_Description: 'Luzon Blinds collection offers range of fabrics & colours to help you create statement look with stunningly eye-catching bold stripes',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/luzon-blinds/',

        name: "Luzon Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-slider-05.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-slider-01-2.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-slider-02-2.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-slider-03-2.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-slider-04.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-21-1.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-22-1.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-23-1.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-24-1.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-25-1.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-26-1.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-27-1.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-28-1.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-29.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-30.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-31.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/04-Luzon-inspiration.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-1.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-2.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-3.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-4.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-5.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-6.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-7.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-8.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-9.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-10.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-11.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-12.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-13.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-14.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-15.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-16.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-17.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-19-1.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/luzon-20-1.webp'
            ],
            text: [
                <>
                    <p>
                        <b>Callistus Luzon Blinds</b> are an innovative window furnishing that features two layers of Sheer-Translucent or Sheer-Dimout horizontal striped fabric that combine to create a striking contemporary feel. Our collection offers you the perfect range of fabrics and colours to help you to create your statement look. Luzon Blind combines the ideal balance of privacy and light control with stunningly eye-catching bold stripes and UV blocking.
                    </p>
                    <p>
                        <b>Callistus Luzon Blinds</b> are available in a wide range of colours and fabrics.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        <b>Callistus Luzon Blinds</b> are an innovative window furnishing that features two layers of Sheer-Translucent or Sheer-Dimout horizontal striped fabric that combine to create a striking contemporary feel. Our collection offers you the perfect range of fabrics and colours to help you to create your statement look.
                    </p>
                    <p>
                        <b>Callistus  Luzon Blinds,</b> also known as Honeycomb Blinds, Cellular Blinds, come with unique light & privacy control combinations including sheer, light filtering, room darkening, and blackout fabrics to provide you with various levels of privacy, light control and luxury.
                    </p>
                    <p>
                        <b>Luzon Blind</b> combines the ideal balance of privacy and light control with stunningly eye-catching bold stripes and UV blocking.
                    </p>
                    <p>
                        <b>Callistus Luzon Blinds</b> are available in a wide range of colours and fabrics. <b>Luzon Blinds</b> also look spectacular in rooms with extra large windows, creating a style statement along with light control.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Translucent & Blackout' },
                { label: 'Width (in mm)', value: '500 to 2850' },
                { label: 'Drop (in mm)', value: '500 to 5500' }
            ],
            video: "https://www.youtube.com/embed/Of71JGb0djo?si=3rJuy8Venssv9WNf",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Luzon Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/LuzonBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/luzon-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/LuzonBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to preset and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall.<br /><Link to="/luzon-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/LuzonBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            Callistus Automation Blinds can be operated using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                <b>Callistus Luzon Blinds</b> are spectacular, stylish, reliable and easy to operate. An assortment of operating system options ensures the blind can be operated with convenience to achieve the required level of privacy and light control.
                            </p>
                            <p>
                                We offer a collection of 57 types of fabrics that raise the brows allowing your imaginations to run wild. The wonderful range allows you to choose from a wide variety of shades to match your interior.
                            </p>
                        </>
                },
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/LuzonBlindsImages/luzon-blinds-decorative-cassette.webp',
                    description: 'Add a touch of luxury to your blind by adding a contemporary cassette. This system improves the look of the blind whether it is in the retracted or extended position. The blind get a glamorous enhancement with a Decorative Cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.'
                },
                {
                    title: 'Fixing Option - Plain Cassette',
                    image: '/Assets/SubPagesImages/LuzonBlindsImages/luzon-blinds-plain-cassette.webp',
                    description: 'Give your blinds a sophisticated look by adding a sleek yet elegant plain cassette. If the blind is pulled up, the fabric in the upper part is wound onto the winding system. In this system, the roller lap is hidden in the box, whose size is determined according to the dimensions of the blinds. Plain Cassette completely encloses your blind’s mechanism thereby maintaining the integrity of your interior.'
                },
                {
                    title: 'Fixing Option - Head Rail',
                    image: '/Assets/SubPagesImages/LuzonBlindsImages/luzon-blinds-head-rail.webp',
                    description: 'This is one of the leading fixing option. Head Rails are essentially the part of the blind which accommodate the operating system that make the blind go up and down. Head Rail blends with any operating system whether Automation or Manual. This fixing option also plays a vital role in maintaining the balance of blinds for bigger measurements.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/LuzonBlindsImages/9.-LKB-1581-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/8.-LGT-1640-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/7.-LET-1506-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/6.-LGT-1634-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/5.-LDT-1552-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/4.-LFT-1522-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/3.-LLB-1603-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/2.-LVT-1615-300x167.webp',
                '/Assets/SubPagesImages/LuzonBlindsImages/1.-LHT-1572-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/luzon-blinds/luzon-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "skylight-blinds": {
        id: "skylight-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Skylight Blinds - making room brighter & open, giving spacious feel',
        META_PG_OG_Description: 'Sunlight can be a little glaring and can be uncomfortably hot. Callistus Skylight Blinds can make a considerable difference to comfort you',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/skylight-blinds/',

        name: "Skylight Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-05.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-04.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-01-1.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-02-1.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-slider-03.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/SkylightBlindsImages/roman_skylight_01.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/06-skylight-inspiration.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-inspiration-03.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-inspiration-07.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-2.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-5.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-inspiration-06.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/skylight-inspiration-04.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/20.webp'
            ],
            text: [
                <>
                    <p>
                        Adding a <b>Skylight</b> can be a great way of making a room brighter and more open, giving a spacious feel.
                    </p>
                    <p>
                        <b>Callistus Skylight blinds</b> available with two options: <b>Skylight Colby Blinds</b> and <b>Skylight  Roman Blinds</b>.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Adding a skylight can be a great way of making a room brighter and more open, giving a spacious feel.
                    </p>
                    <p>
                        But all that sunlight can be a little glaring and can be uncomfortably hot. This is where a Callistus Skylight Blind can make a considerable difference to comfort you in your home/office.
                    </p>
                    <p>
                        Callistus Skylight blinds have two options:
                    </p>
                    <p>
                        <b>Skylight Colby Blinds</b><br />
                        Callistus Skylight Colby Blinds are stylish, functional, versatile and energy efficient window covering solution. They are perfect for any window size and offer insulating properties to control room temperature without compromising on style.
                    </p>
                    <p>
                        <b>Skylight Roman Blinds</b><br />
                        Callistus Skylight Roman Blinds are elegant and provide a modern look.<br />
                        Callistus Roman Blinds are fixed together without any stitch mechanism which offers a very slim look with a feeling of luxury.
                    </p>
                </>
            ],
            specs: [
                { label: 'Visibility', value: 'Sheer, Translucent & Blackout' },
                { label: 'Width (in mm)', value: '1000 to 1500' },
                { label: 'Drop (in mm)', value: '1000 to 4000' }
            ],
            video: "https://www.youtube.com/embed/7oqcU7T4L3o?si=qfv2RuKyR4hGkdQo",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Skylight Blinds",
            systems: [
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/SkylightBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to preset and easily operate blinds with just a press of a button.<br /><Link to="/skylight-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'ManuEasy options for hard to reach Skylightsal',
                    image: null,
                    description:
                        <>
                            Wondering how you would open and close a high, hard-to-reach Skylight? Our unique Automation Systems give you added value and makes complete sense for those hard to reach places. We offer an innovative technology; which helps you satisfy all your automation and convenience needs to make life easier – letting you control your blinds quickly and simply with a remote control.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Enjoy the Light and Control the heat',
                    image: null,
                    description: 'Skylights can often be an integral part of a conservatory and if you have a conservatory, you’ll know they can trap heat in summer and let heat out in the winter. There’s one easy answer – simply add a stylish, energy-efficient Skylight Blind to give you temperature control throughout the year.'
                },
                {
                    title: 'The height of sophistication',
                    image: null,
                    description: 'Exclusive designs, contemporary & classic colours and textures, a choice of transparencies, our complete range of Skylight blinds offer the perfect look for every place.'
                },
                {
                    title: 'Colby Fabrics',
                    image: '/Assets/SubPagesImages/SkylightBlindsImages/skylight-colby.webp',
                    description: 'Callistus Skylight Colby Blinds are stylish, functional, versatile, energy efficient window covering solution. They are perfect for any size or shaped window and offer insulating properties to control room temperature without compromising'
                },
                {
                    title: 'Roman Fabrics',
                    image: '/Assets/SubPagesImages/SkylightBlindsImages/skylight-roman.webp',
                    description: 'Callistus Skylight Roman Blinds are elegant and provide a modern look. Callistus Roman Blinds are fixed together without any stitch mechanism which offers a very slim look and a feeling of luxury.'
                },
                {
                    title: 'Unique Fabric Conversion in Roman Fabrics',
                    image: '/Assets/SubPagesImages/SkylightBlindsImages/skylight-unique-fabric-conversion-icons.png',
                    description: '1st Time Callistus offers Sheer to Translucent to Blackout conversion options available with all our Fabrics for Roman blinds which soothingly distribute and disperse light through the room providing ambiance and character.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/SkylightBlindsImages/9.-1954-ckb.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/8.-1924-cmt.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/7.-1953-ckb.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/6.-1952-ckb.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/5.-1923-cmt.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/4.-1955-ckb.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/3.-1926-cmt.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/2.-1922-cmt.webp',
                '/Assets/SubPagesImages/SkylightBlindsImages/1.-1951-ckb.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/skylight-blinds/skylight-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "panel-blinds": {
        id: "panel-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Panel Blinds displaying the rich fabrics, colour and texture',
        META_PG_OG_Description: 'Panel Blinds are lustrous window decoration for larger windows, bi-fold or patio doors, & a fantastic choice for room dividers as well',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/panel-blinds/',

        name: "Panel Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-04-1.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-05-1.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-01-1-1.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-02-1.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-06.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-07.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-slider-03-1.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-09.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-10.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/08-Panel-inspiration.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/06-Panel-inspiration.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/07-Panel-inspiration.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-01.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-02.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-03.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-04.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-05.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-06.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-07.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/panel-inspiration-08.webp'
            ],
            text: [
                <>
                    <p>
                        <b>Callistus Panel Blinds</b> offer a sleek answer for both large and small window expanses. Panel Blinds stack compactly to offer the maximum view when open, and display the rich fabrics, colour and texture when closed.
                    </p>
                    <p>
                        <b>Panel blinds</b> are an ideal choice for those who want to make an impact and add uniqueness to their interior. With their flexible nature, not only do they make lustrous window decoration for larger windows, bi-fold or patio doors, but they are a fantastic choice for room dividers as well.
                    </p>
                    <p>
                        Dazzling choice of fabrics with 650+ awesome designs and colours available in sheer, translucent and blackout fabric types. Whether it’s a plain, pattern, print or textured fabric, with such a multitude of styles you really will be spoilt for choice with a stunning range of versatile colours, encompassing modern spaces with redefined designs.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Transform your Interior Design with Callistus Panel Blinds. Our Panel Blinds offer a sleek answer for both large and small window expanses. Panel Blinds stack compactly to offer the maximum view when open, and display the rich fabrics, colour and texture when closed.
                    </p>
                    <p>
                        Panel blinds are an ideal choice for those who want to make an impact and add uniqueness to their interior. With their flexible nature, not only do they make lustrous window decoration for larger windows, bi-fold or patio doors, but they are a fantastic choice for room dividers as well.
                    </p>
                    <p>
                        Dazzling choice of fabrics with 650+ awesome designs and colours available in sheer, translucent and blackout fabric types. Whether it’s plain, pattern, print or textured fabric, with such a multitude of styles you really will be spoilt for choice with a stunning range of versatile colours, encompassing modern spaces with redefined designs.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Vertical' },
                { label: 'Visibility', value: 'Sheer, Translucent & Blackout' },
                { label: 'Width (in mm)', value: '600 to 3000' },
                { label: 'Drop (in mm)', value: '600 to 4000' }
            ],
            video: "https://www.youtube.com/embed/NgCKHVWvYsA?si=uUW-_Zx8k34iNsJq",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Panel Blinds",
            systems: [
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to preset and easily operate window blinds with just a press of a button.<br /><Link to="/panel-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Wand Control',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/wand-control-e1589892259253.webp',
                    description:
                        <>
                            Callistus offers Wand Control for Panel Blinds, so there are no cords, making them completely Child Safe by design. You can control the Panels by drawing them to either left or right as per your need.
                        </>
                },
                {
                    title: 'Cord Control',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/cord-control-e1589892901632.webp',
                    description:
                        <>
                            One of the most important advantages of Blinds is their ease of operation. A continuous cord is used to open and close the blinds without any hassles.<br /><Link to="/panel-blinds-cord-control">Learn More</Link>
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Blinds offer textures that are a literal treat to your eyes. With softness and drama of contrasting colours that come in natural and rough texture, they are not only reflective but also look icy elegant.
                            </p>
                            <p>
                                You can choose either left or right draw in Panel Blind to perfectly suit your window requirements. A versatile and contemporary way to control light, glare, view, and privacy; Panel Blinds provide an innovative shading solution for all windows and patio doors
                            </p>
                        </>
                },
                {
                    title: 'Customize your blinds',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/panel-blinds-customization.webp',
                    description: 'Mix and match fabric colours and textures to create an eye-catching statement at your space. All of our fabrics ranges are also available as Roman & Roller Blinds to give you perfect coordination throughout your home. Whatever you require we have got it covered.'
                },
                {
                    title: 'Tracks',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/panel-tracks.webp',
                    description: 'The Head rail in Panel Blinds is available in 3 different variants. You can choose from 3, 4, and 6 track channels as per your requirement.'
                },
                {
                    title: 'Channel Stacking Option',
                    image: '/Assets/SubPagesImages/PanelBlindsImages/stacking-option.webp',
                    description: 'Whilst open, Stack the blinds at a side of your preferences that corresponds with your interior and comforts the eye. Stacking options: Left, Right or Center split.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/PanelBlindsImages/9.-p2fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/8.-p3fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/7.-p1fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/6.-rio-fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/5.-voil-fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/4.-mist-fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/3.-dapple-fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/2.-colortex-fabric.webp',
                '/Assets/SubPagesImages/PanelBlindsImages/1.-plaintex-fabric.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/panel-blinds/panel-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "roman-blinds": {
        id: "roman-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Roman Blinds - Greater Choice with Trending Designs',
        META_PG_OG_Description: 'Roman Blinds are versatile and provide neat modern look. Fold by fold raising property elevates oomph factor by creating soft layered effect',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/roman-blinds/',

        name: "Roman Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/RomanBlindsImages/roman-slider-03-1.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/roman-slider-04-2.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/roman-slider-05-2.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/roman-slider-06.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/roman-slider-07.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/roman-slider-01-1.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/roman-slider-02-1.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/RomanBlindsImages/07-Roman-inspiration.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/08-Roman-inspiration.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/09-Roman-inspiration.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/10-Roman-inspiration.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/01-Roman-inspiration.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/02-Roman-inspiration.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/03-Roman-inspiration.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/04-Roman-inspiration.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/05-Roman-inspiration.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/06-Roman-inspiration.webp'
            ],
            text: [
                <>
                    <p>
                        <b>Roman Blinds</b> are very versatile and provide a neat modern look. Fold by fold raising property elevates the oomph factor by creating a soft layered effect. Unlike other Roman Blinds which are traditionally stitched together, <b>Callistus Roman Blinds</b> are fixed together by using PVC rod and powder coated channel that deter any amount of light to pass through and offer rust resistance in any climate.
                    </p>
                    <p>
                        Greater choice with trending designs – <b>Callistus</b> Range of fabric collection is available in more than 650 stunning and dazzling range of distinctive and versatile colours, encompassing modern spaces with refined designs.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Roman Blinds are very versatile and provide a neat modern look. Fold by fold raising property elevates the oomph factor by creating a soft layered effect. Unlike other Roman Blinds which are traditionally stitched together, Callistus Roman Blinds are fixed together by using PVC rod and powder coated channel that deter any amount of light to pass through and offer rust resistance in any climate.
                    </p>
                    <p>
                        First time in UAE our Roman Blinds Collection have unique offering of Fabric Conversion – Callistus Roman Blinds offer Sheer to Translucent to Blackout conversion options available with all fabrics. Soothingly dispersing light through the room, providing an astonishing ambience, Roman Blinds are the most beautiful and royal Blinds
                    </p>
                    <p>
                        Greater choice with trending designs – Callistus Range of fabric collection is available in more than 650 stunning and dazzling range of distinctive and versatile colours, encompassing modern spaces with refined designs.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Sheer, Translucent & Blackout Fabric conversion available' },
                { label: 'Width (in mm)', value: '500 to 3000' },
                { label: 'Drop (in mm)', value: '1000 to 4000' }
            ],
            video: "https://www.youtube.com/embed/8tVibIgs3Io?si=Mdh6BYoj79Td7GRM",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Roman Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/roman-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to preset and easily operate a group of up-to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to wall.<br /><Link to="/roman-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            Callistus Automation blinds can be operated using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
                {
                    title: 'One Touch Down',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/one-touch-down-e1589892347547.webp',
                    description:
                        <>
                            One Touch Down is a smart system wherein you just need to pull the operating chain, and the blind will start unfolding on its own.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Blinds offer textures that are a literal treat to your eyes. With softness and drama of contrasting colours that come in natural and rough texture, they are not only reflective but also look icy elegant
                            </p>
                            <p>
                                <b>Callistus’ designer fabrics</b> <br />
                                Fabrics that raise the brows allowing your imaginations to run wild. Our wonderful collection allows you to choose from 650+ fabric colours, textures and patterns.
                            </p>
                            <p>
                                <b>Automation in Blinds</b><br />
                                Automation in blinds gives your home a touch of originality, improves function and adds value. It makes complete sense for those hard to reach places. We offer a blend of design, technology and innovation that is easy to use and amazingly versatile. You can also choose from a wide range of portable controllers to fulfill all your automation needs and comforts
                            </p>
                        </>
                },
                {
                    title: 'Unique Fabric Conversion',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/roman-blinds-unique-fabric-conversion.png',
                    description: '1st Time Callistus offers Sheer to Translucent to Blackout conversion options available with all our Fabrics for Roman blinds which soothingly distribute and disperse light through the space providing ambiance and character.'
                },
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/Roman-Decorative-Cassette.webp',
                    description: 'Add a touch of luxury to your blind by adding a contemporary cassette. This fixing improves the look of the blind whether it is in the retracted or extended position. The blind get a glamorous enhancement with a Decorative Cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.'
                },
                {
                    title: 'Bottom Rail',
                    image: '/Assets/SubPagesImages/RomanBlindsImages/Roman-Blinds-Solutions-Bottom-Options-1.webp',
                    description: 'Callistus provides various options in Bottom Rails according to the blinds. We have options of Pentagon and Decorative Bottom Rails with 19 different colours to choose from. These bottom rails blend beautifully with the blinds enhancing their look by making them more stylish and sophisticated.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/RomanBlindsImages/8.-Candid-3011-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/7.-Faustina-4016-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/6.-Blesbok-3505-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/5.-Bloom-3056-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/4.-Loden-3534-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/3.-Tafetta-3002-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/2.-Alayna-3566-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/1.-Geo-3026-300x167.webp',
                '/Assets/SubPagesImages/RomanBlindsImages/9.-Jamboree-3653-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/roman-blinds/roman-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "aric-blinds": {
        id: "aric-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Aric Blinds - the combination of Roller and Vertical Blinds',
        META_PG_OG_Description: 'Exclusive feature that facilitates the opening & closing of sheer part at same position of the blind without rolling the blind up or down',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/aric-blinds/',

        name: "Aric Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/AricBlindsImages/aric-slider-04.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-slider-01-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-slider-02-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-slider-03-1.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-07.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-08.webp',
                '/Assets/SubPagesImages/AricBlindsImages/05-aric-inspiration.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-01.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-02.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-03.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-04.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-05.webp',
                '/Assets/SubPagesImages/AricBlindsImages/aric-inspiration-06.webp'
            ],
            text: [
                <>
                    <p>
                        For the first time, <b>Callistus Window Fashion</b> introduces an innovative operating system in <b>Aric Blinds</b> which offers customers a unique experience of operating <b>Roller and Vertical Blinds</b> simultaneously. <b>Aric Blinds</b> have an exclusive feature that facilitates the opening and closing the sheer part at the same position of the blind without rolling the blind up or down.
                    </p>
                    <p>
                        An amazingly stylish and simple way to control light and privacy at any time of the day or night. Aric Blinds combine the ideal balance of privacy and light control with the fashionable, eye-catching trend of bold stripes and colour blocking. Callistus <b>Aric Blinds</b> are available in fabulous colours and fabrics.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        For the first time in UAE, Callistus Window Fashion introduces an innovative operating system in Aric Blinds which offers customers a unique experience of operating Roller and Vertical Blinds simultaneously. Aric Blinds have an exclusive feature that facilitates the opening and closing the sheer part at the same position of the blind without rolling the blind up or down.
                    </p>
                    <p>
                        An amazingly stylish and simple way to control light and privacy at any time of the day or night. Aric Blinds combine the ideal balance of privacy and light control with the fashionable, eye-catching trend of bold stripes and colour blocking. Callistus Aric Blinds are available in fabulous colours and fabrics.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Combination of Horizontal and Vertical' },
                { label: 'Visibility', value: 'Translucent' },
                { label: 'Width (in mm)', value: '550 to 2500' },
                { label: 'Drop (in mm)', value: '550 to 2500' }
            ],
            video: "https://www.youtube.com/embed/7oqcU7T4L3o?si=3Egpa7N_tDzz8ptY",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Aric Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/AricBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/aric-blinds-manual">Learn More</Link>
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description: 'Callistus Aric blinds are modern in design, stylish, reliable and easy to operate. Fabrics that raise the brows allowing your imaginations to run wild. Our wonderful collection allows you to choose from array of fabrics.'
                },
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/AricBlindsImages/aric-blind-decorative-cassette.webp',
                    description: 'Add a touch of luxury to your blind by adding a contemporary cassette. This fixing improves the look of the blind whether it is in the retracted or extended position. The blind get a glamorous enhancement with a Decorative Cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.'
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/AricBlindsImages/AST-2101-300x167-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/AST-2102-300x167-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/AST-2103-300x167-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/AST-2104-300x167-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/AST-2105-300x167-1.webp',
                '/Assets/SubPagesImages/AricBlindsImages/AST-2106-300x167-1.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "patricia-blinds": {
        id: "patricia-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Patricia Blinds - luxurious to look & latest trendsetter interior',
        META_PG_OG_Description: 'It folds up in most stylish manner forming a unique flower pattern towards bottom that makes room look aesthetic even when blinds are open',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/patricia-blinds/',

        name: "Patricia Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-03-1.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-04.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-05.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-06.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-07.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-08.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-01-1.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia-slider-02-1.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/PatriciaBlindsImages/patricia_inspiration_new01.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/34.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/32.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-08.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-09.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/08-Patricia-inspiration.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/07-Patricia-inspiration.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-01.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-04.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/36.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/Patricia-inspiration-06.webp'
            ],
            text: [
                <>
                    <p>
                        <b>Patricia Blinds</b> are luxurious to look at and are the latest trendsetter in interior designing. They fold up in the most stylish manner forming a unique flower pattern towards the bottom that makes the room look aesthetic even when the blinds are open. Available in variety of colours and texture is to match any interior.
                    </p>
                    <p>
                        <b>Callistus Patricia blinds</b> are beautiful and elegant window blinds that help decorate your interior in the most pleasant and cheerful manner. The range of colours and texture is available to help you build your dream interior with matching Ladder Tapes.
                    </p>
                    <p>
                        <b>Callistus Patricia blinds</b> are an innovative window furnishing that features translucent horizontal striped fabric that combines to create a strikingly modern feel. Our collection offers you the perfect range of fabrics and colours to create a statement look.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Patricia Blinds are luxurious to look at and are the latest trendsetter in interior designing. They fold up in the most stylish manner forming a unique flower pattern towards the bottom that makes the room look aesthetic even when the blinds are open. Available in variety of colours and texture is to match any interior.
                    </p>
                    <p>
                        Callistus Patricia blinds are beautiful and elegant window blinds that help decorate your interior in the most pleasant and cheerful manner. The range of colours and texture is available to help you build your dream interior with matching Ladder Tapes.
                    </p>
                    <p>
                        Callistus Patricia blinds are an innovative window furnishing that features translucent horizontal striped fabric that combines to create a strikingly modern feel. Our collection offers you the perfect range of fabrics and colours to create a statement look.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Translucent' },
                { label: 'Width (in mm)', value: '750 to 4500' },
            ],
            video: "https://www.youtube.com/embed/7oqcU7T4L3o?si=aMKFxmWe0NKh4pFl",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Patricia Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/PatriciaBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/patricia-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/PatriciaBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to preset and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall.<br /><Link to="/patricia-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/PatriciaBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            Callistus Automation blinds can be operated using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Patricia Blinds are modern in design, stylish, reliable and easy to operate. The range of operating system ensures the blind can be operated easily to achieve the required level of privacy and light control for you.
                            </p>
                            <p>
                                Callistus Patricia Blinds are an innovative window covering that feature translucent horizontal striped fabric which combines to create a strikingly contemporary feel. Our collection offers you the perfect range of fabrics and colours to create a statement look.
                            </p>
                            <p>
                                Give your blinds a glamorous enhancement with a matching fabric decorative cassette accompanied by a fascinating lace at the bottom.
                            </p>
                        </>
                },
                {
                    title: 'Unique Flower Pattern',
                    image: '/Assets/SubPagesImages/PatriciaBlindsImages/paricia-blinds-unique-flower-pattern.webp',
                    description: 'The distinctive feature of Patricia Blinds is the shaping up of Flower Pattern. Whilst open, the flower formation of the blind adds a unique value to your windows and adjacent interiors.'
                },
                {
                    title: 'Fabric Decorative Cassette',
                    image: '/Assets/SubPagesImages/PatriciaBlindsImages/paricia-blinds-fabric-decorative-cassette.webp',
                    description: 'Add a touch of luxury to your blind by adding a contemporary cassette. This system improves the look of the blind whether it is in the retracted or extended position. The blind get a glamorous enhancement with a decorative cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.'
                },
                {
                    title: 'Decorative Lace',
                    image: '/Assets/SubPagesImages/PatriciaBlindsImages/paricia-blinds-decorative-lace.webp',
                    description: 'The decorative lace is an alluring insertion to the blind. Ingrained with a mild steel strip for support, the lace plays a versatile role in the blind, essentially adding a touch of conventional decorative articles.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/PatriciaBlindsImages/2.-PCT-2301-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/1.-PCT-2302-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/7.-PCT-2303-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/8.-PCT-2304-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/3.-PCT-2305-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/4.-PCT-2306-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/6.-PCT-2307-th-300x167.webp',
                '/Assets/SubPagesImages/PatriciaBlindsImages/5.-PCT-2308-th-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "dorren-blinds": {
        id: "dorren-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Upgrade of triple shade & has fashionable style of Venetian Blind',
        META_PG_OG_Description: 'A remarkably stylish way to control light & privacy, Callistus Dorren Blinds create perfect look for your window, your mood & your space',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/dorren-blinds/',

        name: "Dorren Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/DorrenBlindsImages/Dorren-Slider-copy.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-slider-01.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-slider-01.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-slider-02.webp',
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-07.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-01.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-02.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-03.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-04.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-05.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/dorren-inspiration-06.webp'
            ],
            text: [
                <>
                    <p>
                        <b>Dorren Blinds</b> have a unique design and are exceptionally easy to operate. They are an upgrade of a triple shade product that has a fashionable style of a Venetian Blind.
                    </p>
                    <p>
                        A remarkably stylish and effortless way to control light and privacy during the day or night, <b>Callistus Dorren Blinds</b> lets you create the perfect look for your window, your mood and your space.
                    </p>
                    <p>
                        <b>Callistus Dorren Blinds</b> are available in a beautiful collection of colours and fabrics. Dorren Blinds also look striking in spaces with extra large windows creating a style statement with excellent light control.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        <b>Dorren Blinds</b> have a unique design and are exceptionally easy to operate. They are an upgrade of a triple shade product that has a fashionable style of a Venetian Blind.
                    </p>
                    <p>
                        A remarkably stylish and effortless way to control light and privacy during the day or night, <b>Callistus Dorren Blinds</b> lets you create the perfect look for your window, your mood and your space.
                    </p>
                    <p>
                        <b>Callistus Dorren Blinds</b> are available in a beautiful collection of colours and fabrics. Dorren Blinds also look striking in spaces with extra large windows creating a style statement with excellent light control.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Translucent' },
                { label: 'Width (in mm)', value: '500 to 2800' },
                { label: 'Drop (in mm)', value: '600 to 4500' }
            ],
            video: "https://www.youtube.com/embed/7oqcU7T4L3o",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Dorren Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/DorrenBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/dorren-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/DorrenBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to preset and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall.
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/DorrenBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            Callistus Automation blinds can be operated using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Dorren Blinds are uniquely designed, elegant, reliable and easy to operate. Options of operating system ensure the blind can be operated conveniently, to achieve the required level of privacy and light control.
                            </p>
                            <p>
                                Dorren Blinds add a touch of spectacular beauty to your interior.
                            </p>
                        </>
                },
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-decorative-cassette.webp',
                    description: 'Add a touch of luxury to your blind by adding a contemporary cassette. This system improves the look of the blind whether it is in the retracted or extended position. The blind gets a glamorous enhancement with a Decorative Cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.'
                },
                {
                    title: 'Fixing Option - Plain Cassette',
                    image: '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-plain-cassette.webp',
                    description: 'Give your blinds a sophisticated look by adding a sleek yet elegant Plain Cassette. When the blind is pulled up, the fabric in the upper part is wound onto the winding system. In this fixing, the roller lap is hidden in the cassette, whose size is determined according to the dimensions of the blinds. Plain Cassette completely encloses your blind’s mechanism thereby maintaining the integrity of your interior.'
                },
                {
                    title: 'Light Diffusion',
                    image: '/Assets/SubPagesImages/DorrenBlindsImages/dorren-blinds-light-diffusion.webp',
                    description: 'Simply tilt the vanes to enjoy more natural daylight by diffusing and spreading it evenly throughout the room whilst filtering out brightness, glare and UV rays.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/DorrenBlindsImages/1.-DVT-2501-300x167.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/4.-DVT-2502-300x167.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/2.-DVT-2503-300x167.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/3.-DVT-2504-300x167.webp',
                '/Assets/SubPagesImages/DorrenBlindsImages/5.-DVT-2505-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "meliso-blinds": {
        id: "meliso-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Meliso Blinds - Fusion of practicality of Roller while adding look of Roman',
        META_PG_OG_Description: 'Meliso Blinds - with gentle pull of cord, textured fabric in palette of delightful colors transforms from contoured folds to opened vanes',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/meliso-blinds/',

        name: "Meliso Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-slider-04.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-slider-01.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-slider-02-1.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-slider-05.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-slider-06.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-slider-03-1.webp',

            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/MelisoBlindsImages/07-Meliso-inspiration.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/09-Meliso-inspiration.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-inspiration-01.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-inspiration-02.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-inspiration-03.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-inspiration-04.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-inspiration-05.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/meliso-inspiration-06.webp',

            ],
            text: [
                <>
                    <p>
                        <b>Callistus Meliso Blind</b> combines the personality of a classic fabric shade with the ability to control light in an entirely new way. With the gentle pull of the operating cord, textured fabric in a palette of delightful colours transforms from contoured folds to opened vanes, allowing a softened outside view through the sheer backing.
                    </p>
                    <p>
                        These modern blinds are designed delicately and creatively. They are a fusion of the practicality of Roller Blinds while adding the look of Roman Blinds when pulled up.
                    </p>
                    <p>
                        When the Blinds are drawn, they have horizontal stripes as their signature design created with their fabric and have a unique feature of coming down like roller blinds. The sheer look adds an elegant touch to the ordinary Roller Blinds and Roman Blinds and brings out a new look altogether.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Let softly diffused light spill into your favourite room.
                    </p>
                    <p>
                        <b>Callistus Meliso Blind</b> combines the personality of a classic fabric shade with the ability to control light in an entirely new way. With the gentle pull of the operating cord, textured fabric in a palette of delightful colours transforms from contoured folds to opened vanes, allowing a softened outside view through the sheer backing.
                    </p>
                    <p>
                        These modern blinds are designed delicately and creatively. They are a fusion of the practicality of Roller Blinds while adding the look of Roman Blinds when pulled up.
                    </p>
                    <p>
                        When the Blinds are drawn, they have horizontal stripes as their signature design created with their fabric and have a unique feature of coming down like roller blinds. The sheer look adds an elegant touch to the ordinary Roller Blinds and Roman Blinds and brings out a new look altogether.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Horizontal' },
                { label: 'Visibility', value: 'Translucent' },
                { label: 'Width (in mm)', value: '500 to 2600' },
            ],
            video: "https://www.youtube.com/embed/7oqcU7T4L3o",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Meliso Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/MelisoBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/MelisoBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to preset and easily operate a group of up to sixteen different window blinds, individually or together with just a press of a button. Remote Controls can also be affixed to a wall.<br /><Link to="/meliso-blinds-remote-control">Learn More</Link>
                        </>
                },
                {
                    title: 'Smart Phone Control',
                    image: '/Assets/SubPagesImages/MelisoBlindsImages/Smart-Phone-e1589892231661.webp',
                    description:
                        <>
                            Callistus Automation blinds can be operated using an App. You can control your blinds with a swipe of a finger, or create customized scenes that move the blinds to positions you set. Also, you can automate those scenes to operate on their own throughout the day.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Meliso Blinds are modern in design, stylish, reliable and easy to operate. Range of operating system ensures the blind can be rolled up or down easily to achieve the required level of privacy and light control.
                            </p>
                        </>
                },
                {
                    title: 'Fixing Option - Decorative Cassette',
                    image: '/Assets/SubPagesImages/MelisoBlindsImages/meliso-blinds-decorative-cassette.webp',
                    description: 'Add a touch of luxury to your blind by adding a contemporary cassette. This system improves the look of the blind whether it is in the retracted or extended position. The blind get a glamorous enhancement with a Decorative Cassette which is fitted at the top, discreetly housing the operating mechanism. A fabric strip is used to amalgamate the cassette with the blind fabric, complementing the interior eventually.'
                },
                {
                    title: 'Fixing Option - Plain Cassette',
                    image: '/Assets/SubPagesImages/MelisoBlindsImages/meliso-blinds-plain-cassette.webp',
                    description: 'Give your blinds a sophisticated look by adding a sleek yet elegant Plain Cassette. If the blind is pulled up, the fabric in the upper part is wound into the winding system. In this system, the roller lap is hidden in the box, whose size is determined according to the dimensions of the blinds. Plain Cassette completely encloses your blind’s mechanism thereby maintaining the integrity of your interior.'
                },
                {
                    title: 'Light Diffusion',
                    image: '/Assets/SubPagesImages/MelisoBlindsImages/meliso-blinds-light-diffusion.webp',
                    description: 'Simply tilt the vanes to enjoy more natural daylight by diffusing and spreading it evenly throughout the room whilst filtering out brightness, glare and UV rays.'
                }
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/MelisoBlindsImages/1.-MDT-2001-300x167.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/2.-MDT-2002-300x167.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/3.-MDT-2003-300x167.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/4.-MDT-2004-300x167.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/5.-MDT-2005-300x167.webp',
                '/Assets/SubPagesImages/MelisoBlindsImages/6.-MDT-2006-300x167.webp',
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "vertical-blinds": {
        id: "vertical-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Vertical Blinds with wide range of fabrics, colors, textures & patterns',
        META_PG_OG_Description: 'Sliding glass doors, bay windows look prettier with our custom-made Vertical Blinds, which feature easy operation and superior light control.',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/vertical-blinds/',

        name: "Vertical Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/VerticalBlindsImages/vertical-blinds-02.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/vertical-blinds-01.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/vertical-slider-41.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-5.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-06.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-01.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-02.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-03.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-04.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/Vertical-Inspiration-05.webp'
            ],
            text: [
                <>
                    <p>
                        Callistus Vertical Blinds are easy and precise light control solution. Sliding glass doors, bay windows look prettier with our custom-made <b>Vertical Blinds</b> , which feature easy operation and superior light control. Our Vertical Blinds are available in a wide range of fabrics and an impressive array of colours, textures and patterns.
                    </p>
                    <p>
                        Sliding doors can let a lot of light in, consider using a light-filtering, room darkening or blackout <b>Vertical blind</b> on them to help protect furnishings from fading, and for more privacy. Enhanced light control can also help reduce energy costs.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        Callistus Vertical Blinds are easy and precise light control solution. Everything from sliding glass doors to bay windows looks prettier with our custom-made <b>Vertical Blinds</b>, which feature easy operation and superior light control.  Our Vertical Blinds are available in a wide range of fabrics and an impressive array of colours, textures and patterns.
                    </p>
                    <p>
                        Sliding doors can let a lot of light in, consider using a light-filtering, room darkening or blackout <b>Vertical blind</b> on them to help protect furnishings from fading, and for more privacy. Enhanced light control can also help reduce energy costs.
                    </p>
                </>
            ],
            specs: [
                { label: 'Louvre Size (in mm)', value: '100' },
                { label: 'Orientation', value: 'Vertical' },
                { label: 'Width (in mm)', value: '500 to 4500 (with Automation 4000)' },
                { label: 'Drop (in mm)', value: '400 to 4500' },
            ],
            video: "https://www.youtube.com/embed/7oqcU7T4L3o",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Vertical Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/VerticalBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.
                        </>
                },
                {
                    title: 'Remote Control',
                    image: '/Assets/SubPagesImages/VerticalBlindsImages/Remote-150x150-1.webp',
                    description:
                        <>
                            The Remote Control allows you to preset and easily operate window blinds with just a press of a button.
                        </>
                },
                {
                    title: 'Wand Control',
                    image: '/Assets/SubPagesImages/VerticalBlindsImages/wand-control-e1589892259253.webp',
                    description:
                        <>
                            Callistus offers Wand control for Vertical blinds, so there are no cords, making them completely Child Safe by Design. You can control the blind and draw it to either the left or right as per your need.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Blinds offer textures that are a literal treat to your eyes. With softness and drama of contrasting colours that come in natural and rough texture, they are not only reflective but also look icy elegant.
                            </p>
                            <p>
                                You can choose either left or right draw panel blind to perfectly suit your window requirements. A versatile and contemporary way to control light, glare, view and privacy, panel blinds provide an innovative shading solution for all windows and patio doors.
                            </p>
                        </>
                },
                {
                    title: 'Customize your blinds',
                    image: null,
                    description: 'Mix and match fabric colours and textures to create an eye-catching statement in your home/office. There are 100+ fabrics range available to give you perfect coordination throughout your interior. Whatever you require we’ve got it!'
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/VerticalBlindsImages/9.-revolve.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/8.-lark.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/7.-screenline.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/6.-Zig-Zag.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/5.-jentex.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/4.-impact.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/3.-ample2.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/2-equate-thumb-300x167-1.webp',
                '/Assets/SubPagesImages/VerticalBlindsImages/1-Flaxen-thumb-300x167-1.webp'
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: "View More Fabrics",
            ViewMoreLink: "/products/vertical-blinds/vertical-fabric",
            galleryButton: "Click here for Nearest Gallery"
        }
    },

    "eton-blinds": {
        id: "eton-blinds",

        // Page Meta Fields
        META_PG_OG_Title: 'Eton Blinds - soft intimate feel of Curtains & unique benefits of blinds',
        META_PG_OG_Description: 'Eton Blinds - perfect for any window size. Drawn open like curtains & fabric vanes can be rotated with the simple twist of the wand',
        META_PG_Canonical_OG_URL: 'https://callistusblinds.com/products/eton-blinds/',

        name: "Eton Blinds",
        heroSlider: {
            images: [
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-04.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-06.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-07.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-08.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-01-2.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-05.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-02-2.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-slider-03-2.webp'
            ],
        },
        inspirationSlider: {
            images: [
                '/Assets/SubPagesImages/EtonBlindsImages/eton-inspiration-08.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/08-Eton-inspiration.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/09-Eton-inspiration.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-inspiration-01.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-new.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-inspiration-03.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-inspiration-04.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-inspiration-05.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-inspiration-06.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/eton-inspiration-07.webp'
            ],
            text: [
                <>
                    <p>
                        With soft intimate feel of Curtains and unique benefits of blinds <b>Callistus Eton Blinds</b> offer a softly filtered view providing privacy with easily controlled tilting vanes. The luxurious look of soft curtains is accentuated at night when the blind is closed. Callistus Eton Blinds control sunlight in the most effective manner.
                    </p>
                    <p>
                        Eton Blinds are perfect for any window size. Drawn open like curtains, the sheers can be drawn closed and the fabric vanes can be rotated like Vertical Blinds, with the simple twist of the wand.
                    </p>
                    <p>
                        Callistus Eton Blind combines the ideal balance of privacy and light control with fashionable and eye-catching colours.
                    </p>
                </>
            ]
        },
        overview: {
            text: [
                <>
                    <p>
                        With soft intimate feel of Curtains and unique benefits of blinds Callistus Eton Blinds offer a softly filtered view providing privacy with easily controlled tilting vanes. The luxurious look of soft curtains is accentuated at night when the blind is closed. Callistus Eton Blinds control sunlight in the most effective manner.
                    </p>
                    <p>
                        Eton Blinds are perfect for any window size. Drawn open like curtains, the sheers can be drawn closed and the fabric vanes can be rotated like Vertical Blinds, with the simple twist of the wand.
                    </p>
                    <p>
                        An amazingly stylish and simple way to control light and privacy at any time of the day or night, Callistus Eton Blinds let you effortlessly slide two stylish fabrics past each other in an open, half-open or completely closed position to create the perfect look.
                    </p>
                    <p>
                        Callistus Eton Blind combines the ideal balance of privacy and light control with fashionable and eye-catching colours.
                    </p>
                </>
            ],
            specs: [
                { label: 'Orientation', value: 'Vertical' },
                { label: 'Visibility', value: 'Translucent' },
                { label: 'Width (in mm)', value: '500 to 4500 mm' },
            ],
            video: "https://www.youtube.com/embed/Gzxsw47JCVI?si=Okx5RKjpnoEw0xq1",
            videoButton: "Click for More Videos"
        },
        operatingSystems: {
            title: "Available Operating Systems for Eton Blinds",
            systems: [
                {
                    title: 'Manual',
                    image: '/Assets/SubPagesImages/EtonBlindsImages/manual-1-150x150-1.webp',
                    description:
                        <>
                            One of the most important advantages of Callistus window coverings is their ease of operation. A continuous ball chain loop works on the principle of a pulley, rotating a clutch to open or close the blind.<br /><Link to="/eton-blinds-manual">Learn More</Link>
                        </>
                },
                {
                    title: 'Wand Control',
                    image: '/Assets/SubPagesImages/EtonBlindsImages/wand-control-e1589892259253.webp',
                    description:
                        <>
                            Callistus offers Wand control for Eton Blinds, so there are no cords, making them completely Child Safe by Design. You can control the blind and draw it to either the left or right as per your need.
                        </>
                },
            ]
        },
        solutions: {
            text: [
                null
            ],
            combinations: [
                {
                    title: 'Fabric that owns a unique feel',
                    image: null,
                    description:
                        <>
                            <p>
                                Callistus Eton Blinds are well designed, easy to operate, stylish, and durable. A wide array of operating systems ensures the blind can be tilted easily to achieve the required level of light and privacy.
                            </p>
                            <p>
                                Our Eton Blinds sweep elegantly across your windows and doors creating a luxurious ambience at your space.
                            </p>
                            <p>
                                Make Eton blinds your first choice for a beautiful look and full flexibility for your living space.
                            </p>
                            <p>
                                By adding a designer look to your home interiors, Eton Blinds will give you a wow feeling.
                            </p>
                        </>
                },
                {
                    title: 'Fabric Vanes',
                    image: '/Assets/SubPagesImages/EtonBlindsImages/eton-blinds-fabric-vanes.webp',
                    description:
                        <>
                            <p>
                                <b>Full View</b> <br />
                                Slide the soft fabric vanes to one side or split from center to enjoy a clear outside view.
                            </p>
                            <p>
                                <b>Day Time with Privacy</b> <br />
                                Open up the soft fabric vanes to open position and enjoy subtle light diffusion with a view.
                            </p>
                            <p>
                                <b>Total Privacy</b> <br />
                                Rotate the vanes to close the blind fully for total privacy.
                            </p>
                        </>
                },
            ]
        },
        fabrics: {
            title: "A FEW OF OUR FAVORITE FABRICS",
            thumbnails: [
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2221-300x167.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2222-300x167.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2223-300x167.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2224-300x167.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2225-300x167.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2226-300x167.webp',
                '/Assets/SubPagesImages/EtonBlindsImages/EFT-2227-300x167.webp'
            ],
            description:
                <>
                    This is just a sampling of our fabric choices. Visit your local <b style={{ color: "#000" }}>Callistus Gallery</b> to see and feel the full array of fabrics, shades, textures and display blinds.
                </>,
            viewMoreButton: null,
            ViewMoreLink: null,
            galleryButton: "Click here for Nearest Gallery"
        }
    },
};

